export default class AiChatCategory {

    public id = null;

    public name = "";
}